import { gql } from '@apollo/client';

import { GRAPHQL } from '../../constants';

const explainedTermFields = gql`
  fragment explainedTermFields on ExplainedTerm {
    __typename
    detailsTeaser
    id: _id
    marketingOrSalesCTA {
      description: descriptionRaw
      name
      slogan: sloganRaw
      summary: summaryRaw
      ${GRAPHQL.IMAGE_OBJECT}
      ${GRAPHQL.SLUG}
      ${GRAPHQL.URL_OBJECT}
    }
    name
    slogan: sloganRaw
    summary: summaryRaw
    ${GRAPHQL.SLUG}
    ${GRAPHQL.URL_OBJECT}
    ${GRAPHQL.IMAGE_OBJECT}
  }
`;

export default explainedTermFields;
